import React from 'react';
import Nivel2Form from './Nivel2';
import { Link, Route } from 'react-router-dom'
import Nivel2TipoMovimento from './Nivel2TipoMovimento'
import CriarFluxo from './CriarFluxo';

class CriarFluxoTabs extends React.Component {

    componentDidMount() {
        this.props.history.push(
            `/conta_regras_form/gestaoRegras/regrasMovimento`
        );
    }

  render() {
    return (
      <div className="mt-4">
        <ul className="nav nav-tabs tab-container ml-3">
          <li className="nav-item">
            <Link className={ `nav-link p-3 border ${this.props.location.pathname.includes('regrasMovimento') ? 'active' : 'bg-white text-body'}` } to={ { pathname: 'regrasMovimento', search: this.props.location.search } }><span className="k-icon k-i-menu"></span>&nbsp;Regras dos Movimentos</Link>
          </li>
          <li className="nav-item">
            <Link className={ `nav-link p-3 border ${this.props.location.pathname.includes('tipoMovimento') ? 'active' : 'bg-white text-body'}` } to={ { pathname: 'tipoMovimento', search: this.props.location.search } }><span className="k-icon k-i-menu"></span>&nbsp;Tipos dos Movimentos</Link>
          </li>
        </ul>
        <div className="table-section custom-k-grid pt-3">
          <div className="table-responsive">
            <Route path={ `${this.props.match.path}/regrasMovimento` } component={CriarFluxo} />
            <Route path={ `${this.props.match.path}/tipoMovimento` } component={CriarFluxo} />
          </div>
        </div>
      </div>
    )
  }
}

export default CriarFluxoTabs;
